<!--
 * @Author: Alfred huqitaoit@gmail.com
 * @Date: 2024-07-29 14:48:56
 * @LastEditors: Alfred
 * @LastEditTime: 2024-07-29 16:27:27
 * @Description:
-->
<template>
  <div class="tuolele-main-box set-combo">
    <div class="tuolele-main-search tuolele-main-search-item">
      <el-date-picker
        v-model="dateTime"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        @change="init"
      />
      <!-- <el-button type="primary" style="margin-left:10px" @click="fnSetTime">设置导出时间</el-button> -->

    </div>
    <div style="color:#f97559;font-weight: bold;padding-bottom: 10px;">注：点击导出按钮会在新窗口弹出结果，如果数据量比较大，导出时间会比较长，如果没有数据在新页面也会有提示<br>避免重复点击，按钮点击后会被禁用，切换时间会重新初始化按钮</div>
    <div class="tuolele-main-content">

      <div class="form_btn">
        <el-button type="primary" :disabled="isDisabled26" :loading="isLoading26" @click="exportExcel('cms_26')">导出-学员积分数据</el-button>
        <el-button type="primary" :disabled="isDisabled4" :loading="isLoading4" @click="exportExcel('cms_4')">导出-托乐乐上门数据</el-button>
        <el-button type="primary" :disabled="isDisabledj1" :loading="isLoadingj1" @click="exportExcel('cms_j1')">导出-学员体能训练数据</el-button>
        <el-button type="primary" :disabled="isDisabledj3" :loading="isLoadingj3" @click="exportExcel('cms_3')">导出-导出结课数据</el-button>

      </div>
    </div>
  </div>
</template>
<script>
import Tool from '@/assets/js/tool.js'
var moment = require('moment')
export default {
  name: 'DownloadReport',
  components: {

  },
  data() {
    return {
      listQuery: {
        begin_time: '',
        end_time: ''
      },
      dateTime: '',
      isDisabled26: false,
      isLoading26: false,
      isDisabled4: false,
      isLoading4: false,
      isDisabledj1: false,
      isLoadingj1: false,
      isDisabledj3: false,
      isLoadingj3: false
    }
  },
  mounted() {

  },
  methods: {
    exportExcel(id) {
      if (!this.dateTime) {
        this.$message({
          message: '请选择导出时间',
          type: 'warning'
        })
        return
      }
      var begin_time = moment(this.dateTime[0]).format('YYYY-MM-DD')
      var end_time = moment(this.dateTime[1]).format('YYYY-MM-DD')
      this[`isDisabled${id}`] = true
      this[`isLoading${id}`] = true
      const url = process.env.VUE_APP_BASE_URL
      var reportUrl = `${url}/Exceldownload/download?id=${id}&beginTime=${begin_time}&endTime=${end_time}`
      window.open(reportUrl)
    },
    init() {
      this.isDisabled26 = false
      this.isLoading26 = false
      this.isDisabled4 = false
      this.isLoading4 = false
      this.isDisabledj1 = false
      this.isLoadingj1 = false
    }
  }
}

</script>
<style lang="scss">
  .wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.set-combo {
  .self-table {
    margin-top: 0 !important;
  }
  .el-form-item__label {
    font-size: 16px;
    color: #333;
  }
  .el-form-item__content {
    margin: 0 20px 0 12px;
  }
  .el-button.el-button-confirm {
    width: 80px !important;
  }

}
::v-deep .el-table{
     .el-table__footer-wrapper tbody td{
      color: red !important;
    }
  }
</style>
